<div class="my-3 mx-4">
	<mat-card appearance="outlined">
		<mat-card-title>SMS</mat-card-title>

		<mat-card-content>
			@if (loader()) {
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			} @else {
				@if (reservationSmsList().length > 0) {
					<table mat-table [dataSource]="reservationSmsList()">
						<ng-container matColumnDef="message">
							<th mat-header-cell *matHeaderCellDef>Wiadomość</th>
							<td mat-cell *matCellDef="let element">
								<div class="py-2" [innerHTML]="element.message"></div>
							</td>
						</ng-container>

						<ng-container matColumnDef="createdAt">
							<th mat-header-cell *matHeaderCellDef>Utworzono</th>
							<td mat-cell *matCellDef="let element">
								{{ element.createdAt | date: 'dd.MM.YYYY | HH:mm' }}
							</td>
						</ng-container>

						<ng-container matColumnDef="userName">
							<th mat-header-cell *matHeaderCellDef>Klient</th>
							<td mat-cell *matCellDef="let element">
								{{ element.recipient.firstName }} {{ element.recipient.lastName }}
							</td>
						</ng-container>

						<ng-container matColumnDef="phone">
							<th mat-header-cell *matHeaderCellDef>Tel.</th>
							<td mat-cell *matCellDef="let element">{{ element.recipient.phone }}</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
					</table>
				} @else {
					<h4 class="text-center">Brak wysłanych SMS'ów</h4>
				}
			}
		</mat-card-content>
	</mat-card>
</div>
